export const authTokenSelector = (state) =>
  state?.auth?.loggedIn ? state.auth.token : state.tfa.token;

export const authRedirectAfterLoginSelector = (state) => state?.auth?.redirectAfterLogin;
